import React from "react";
import { Users, Calendar, Star } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { api1 } from "../../utils/axiosInstance";
import SecondaryLoader from "../SecondaryLoader/SecondaryLoader";

const DiscussWithMentor = () => {
  const navigate = useNavigate();
  const mentorId = "685339e2fa271e1f1ced0788";
  
  const { data: mentorProfile, isLoading, error } = useQuery({
    queryKey: ["mentorProfile", mentorId],
    queryFn: async () => {
      const response = await api1.get(`/api/mentorProfile/${mentorId}`);
      return response.data.data;
    },
    enabled: !!mentorId,
    staleTime: 5 * 60 * 1000, 
  });

  const mentorName = mentorProfile?.firstName && mentorProfile?.lastName 
    ? `${mentorProfile.firstName} ${mentorProfile.lastName}` 
    : "PASIMA- Mentor SULE";
  const mentorTitle = mentorProfile?.currentJobOccupation || "Chief Executive Officer";
  const rating = "4.9"; 
  const reviews = "500+"; 
  const buttonText = "Book Assessment Review";
  const showSecondButton = true;
  const description = mentorProfile?.bio || "Get expert guidance";
  const icon = <Users className="w-5 h-5 text-purple-900" />;

  if (isLoading) {
    return (
      <div className="bg-white rounded-lg hover:shadow-lg p-4 sm:p-6 border border-gray-400">
        <div className="flex items-center justify-center py-8">
          <SecondaryLoader />
        </div>
      </div>
    );
  }

  if (error) {
    console.error("Error fetching mentor profile:", error);
  }
  
  return (
    <div className={'bg-white rounded-lg hover:shadow-lg p-4 sm:p-6 border border-gray-400'}>
      <div className="mb-4">
        <div className="flex items-center gap-2 mb-2">
          {React.cloneElement(icon, { 
            className: "w-4 h-4 sm:w-5 sm:h-5 text-purple-900" 
          })}
          <h2 className="text-base sm:text-lg font-semibold text-gray-900">Discuss with a Mentor</h2>
        </div>
        <p className="text-gray-500 text-xs sm:text-sm mb-3">{description}</p>
      </div>

        <div className="flex items-center gap-3 sm:gap-4 mb-4 border border-gray-400 rounded-lg p-3 sm:p-4">
          <div className="w-10 h-10 sm:w-12 sm:h-12 bg-gray-200 rounded-full flex items-center justify-center flex-shrink-0 overflow-hidden">
            {mentorProfile?.profileImage ? (
              <img 
                src={mentorProfile.profileImage} 
                alt={mentorName}
                className="w-full h-full object-cover rounded-full"
                onError={(e) => {
                  e.target.style.display = 'none';
                  e.target.nextSibling.style.display = 'flex';
                }}
              />
            ) : null}
            <div className={`w-full h-full flex items-center justify-center ${mentorProfile?.profileImage ? 'hidden' : 'flex'}`}>
              <Users className="w-4 h-4 sm:w-5 sm:h-5 text-gray-400" />
            </div>
          </div>
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 mb-1">
            <h3 className="font-semibold text-sm text-gray-900">{mentorName}</h3>
            <span className="bg-purple-100 text-purple-700 text-xs px-2 py-1 rounded-full flex-shrink-0">Expert</span>
          </div>
          <p className="text-gray-600 text-xs mb-2">{mentorTitle}</p>
          <div className="flex items-center gap-3 sm:gap-4 text-xs sm:text-sm text-gray-500">
            <div className="flex items-center gap-1">
              <Star className="w-3 h-3 sm:w-4 sm:h-4 text-yellow-400 fill-current" />
              <span>{rating}</span>
            </div>
            <div className="flex items-center gap-1">
              <Users className="w-3 h-3 sm:w-4 sm:h-4" />
              <span>{reviews}</span>
            </div>
          </div>
        </div>
      </div>

      <div className="space-y-2 sm:space-y-3">
        <button 
          onClick={() => navigate("/dashboard/mentors-and-community/mentorship")}
          className="w-full bg-gradient-to-r from-purple-600 to-purple-700 text-white text-sm py-2.5 sm:py-3 px-4 rounded-lg font-medium hover:from-purple-700 hover:to-purple-800 transition-all duration-200 flex items-center justify-center gap-2 shadow-sm hover:shadow-md"
        >
          <Calendar className="w-4 h-4" />
          {buttonText}
        </button>
        {showSecondButton && (
          <button 
            onClick={() => navigate(`/dashboard/book-appointment/${mentorId}`)}
            className="w-full border border-gray-300 text-sm text-gray-700 py-2.5 sm:py-3 px-4 rounded-lg font-medium hover:bg-gray-50 hover:border-gray-400 transition-all duration-200 flex items-center justify-center gap-2"
          >
            <Calendar className="w-4 h-4" />
            Free 15min Consult
          </button>
        )}
      </div>
    </div>
  );
};

export default DiscussWithMentor; 